export const overdraftDetail = {
    overdraftCollapsible: {
        showOverDraftName: false,
        showApprovedLimit: false,
        showContractNumber: false,
        showDateSpan: false,
        showReviewDate: false,
        showLimitValidity: false,
        showNextInstallmentDate: false,
    },
};
